/* eslint-disable react/prop-types */
import React from "react";

const MatchCard = ({ league, category, sport, teams, marketName, outcomeName, odds, isLive, status, scheduled }) => {
	const formattedDate = new Date(scheduled * 1000).toLocaleString("en-GB", {
		weekday: "short",
		day: "2-digit",
		month: "short",
		year: "numeric",
		hour: "2-digit",
		minute: "2-digit",
		hour12: false,
		timeZoneName: "short",
	});

	return (
		<article className="card" aria-labelledby="match-title">
			<div className="header">
				<div>
					<div className="league" id="match-title">
						{league} — {marketName}
					</div>
					<div style={{ marginTop: 6, fontSize: 14, fontWeight: 600 }}>{category}</div>
				</div>
				<div className="sport">{sport}</div>
			</div>

			<div className="teams" aria-hidden="false">
				<div className="team">
					<div className="name">{teams[0]}</div>
				</div>
				<div className="vs">vs</div>
				<div className="team">
					<div className="name">{teams[1]}</div>
				</div>
			</div>

			<div className="meta" role="list">
				<div className="pill" role="listitem">
					Market: {marketName}
				</div>
				<div className="pill" role="listitem">
					Outcome: {outcomeName}
				</div>
			</div>

			<div className="market">
				<div className="outcome">{outcomeName}</div>
				<div className="odds" aria-label="Odds">
					{odds}
				</div>
			</div>

			<div className="status">
				<div className={`badge ${isLive ? "live" : "not-live"}`} title={isLive ? "Match is live" : "Match is not live"}>
					{isLive ? "Live" : "Pre-match"}
				</div>
				<div className={`badge ${status.toLowerCase()}`} title="Bet status">
					{status}
				</div>
			</div>

			<div className="footer">
				<div>
					<div style={{ fontWeight: 700, color: "#cfe8ff" }}>Kick-off</div>
					<div style={{ marginTop: 4 }}>{formattedDate}</div>
				</div>
				<div style={{ textAlign: "right" }}>
					<div style={{ fontWeight: 700, color: "var(--muted)", fontSize: 12 }}>Odds provided</div>
					<div style={{ marginTop: 6, fontSize: 12, color: "var(--muted)" }}>{odds}</div>
				</div>
			</div>
		</article>
	);
};

export default MatchCard;
